import { Link } from 'react-router-dom';

const footerLinks = {
  pages: [
    { name: 'Home', path: '/' },
    { name: 'Shopping Guide', path: '/sugargoo-spreadsheet-guide' },
    { name: 'Best Spreadsheet 2026', path: '/best-sugargoo-spreadsheet-2026' },
    { name: 'Beginner Guide', path: '/sugargoo-beginner-guide' },
    { name: 'Safety Center', path: '/sugargoo-safety-guide' },
    { name: 'QC Guide', path: '/sugargoo-qc-guide' },
    { name: 'Shipping Guide', path: '/sugargoo-shipping-guide' },
  ],
  categories: [
    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
    { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
    { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
    { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
  ],
  legal: [
    { name: 'Best Spreadsheet 2026', path: '/best-sugargoo-spreadsheet-2026' },
    { name: 'Category Guide', path: '/sugargoo-spreadsheet-by-category' },
    { name: 'Budget Finds', path: '/best-budget-finds-sugargoo' },
    { name: 'Brands Guide', path: '/sugargoo-spreadsheet-brands' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="section-container py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-leaf-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-semibold">Sugargoo Sheet</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              Your trusted resource for the latest Sugargoo spreadsheet finds, QC guides, and shopping safety tips. Helping you discover the best products with confidence.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-reddit-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-discord-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Pages */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-6">Site Pages</h4>
            <ul className="space-y-3">
              {footerLinks.pages.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-6 mt-8">Popular Categories</h4>
            <ul className="space-y-3">
              {footerLinks.categories.map((link) => (
                <li key={link.name}>
                  <a href={link.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-6">More Articles</h4>
            <ul className="space-y-3 mb-8">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Visit Main Site
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-700/40">
        <div className="section-container flex flex-col sm:flex-row items-center justify-between py-5 gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet Watch. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            This website is an informational resource and is not affiliated with Sugargoo.
          </p>
        </div>
      </div>
    </footer>
  );
}